import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import styles from "./ReportSearchDropdown.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

const ReportSearchDropdown = ({
  label,
  options,
  defaultValue,
  isYear,
  isFilter,
  onSelect,
}) => {
  const currentYear = new Date().getFullYear();
  const [selectedOption, setSelectedOption] = useState(defaultValue);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setSelectedOption(defaultValue);
  }, [defaultValue]);
  // const filteredOptions = isYear
  //   ? [currentYear, ...options.filter((year) => year !== currentYear)]
  //   : [defaultValue, ...options.filter((option) => option !== defaultValue)];
  const filteredOptions = options;

  const handleSelect = (option) => {
    // if (!isYear && option === defaultValue) {
    //   setIsOpen(false);
    //   return;
    // }

    setSelectedOption(option);
    setIsOpen(false);
    if (onSelect) {
      onSelect(option);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={styles.container}>
      <label className={styles.label}>{label}</label>
      <div
        ref={dropdownRef}
        className={styles.wrapper}
        style={{ width: isYear ? "100px" : isFilter ? "300px" : "250px" }}
      >
        <div
          className={`${styles.dropdown} ${isOpen ? styles.open : ""}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span>{selectedOption}</span>
          <FontAwesomeIcon
            icon={isOpen ? faChevronUp : faChevronDown}
            className={styles.icon}
          />
        </div>

        {isOpen && (
          <ul className={styles.menu}>
            {filteredOptions.map((option, index) => (
              <li
                key={option}
                className={styles.menuItem}
                onClick={() => handleSelect(option)}
              >
                {option}
                {(isYear && index === 0) || (!isYear && index === 0) ? (
                  // option === defaultValue
                  <FontAwesomeIcon
                    icon={faChevronUp}
                    className={styles.menuChevron}
                  />
                ) : null}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

ReportSearchDropdown.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  isYear: PropTypes.bool,
  onSelect: PropTypes.func,
};

export default ReportSearchDropdown;
